import React, { useState } from 'react';
import Popup from './Popup';
import Popup_content from './Popup_content';
import {Link } from "react-router-dom";
import Program_Popup from './Program_Popup';
import Program_Popup_Content from './Program_Popup_Content';
import logo from '../Image/logo.avif'

function Navbar_mobile() {
  
   const [isOpen, setIsOpen] = useState(false);
    const togglePopup = () => {
    setIsOpen(!isOpen);
  }
  const [isOpen1, setIsOpen1] = useState(false);
    const togglePopup1 = () => {
    setIsOpen1(!isOpen1);
  }
 
 

  return (
    <div>
    <nav>
        <ul class='nav-bar'> 
            <li class='logo'><Link to="/"><img className='mt-1' src={logo}></img></Link></li>
            <input type='checkbox' id='check' />
            <span class="Navbar">
            <li className="">
                <Link className="nav-link text-dark" to="/">Home</Link>
                </li>
                <li className="">
                <Link className="nav-link text-dark" to="/About-us">About</Link>
                </li>
                <li className="d-none d-xl-block">
                <Link className="nav-link text-dark" to={"#"} onClick={togglePopup}>Program {isOpen && <Program_Popup content={<><Program_Popup_Content/></>}
                handleClose={togglePopup}/>}</Link>
                </li>
                <li className='d-xl-none d-md-block'><Link to="/Program" className="nav-link text-dark">Program</Link></li>
                <li className="">
                {/* <Link to="/Bootcamps" className="nav-link text-dark">Bootcamps</Link> */}
                </li>
                <li className="d-none d-xl-block">
                <Link className="nav-link text-dark" to={"#"} onClick={togglePopup1}>Careers {isOpen1 && <Popup content={<><Popup_content/></>}
                handleClose={togglePopup1}/>}</Link>
                </li>
                <li className='d-xl-none d-md-block'><Link to="/Careers" className="nav-link text-dark">Careers</Link></li>
                <li className="">
                <Link className="nav-link text-dark" to="/Contact">Contact</Link>
                </li>
                <li>
                <Link to='/Student_register'><button className="text-white shadow-sm mx-4 fs-6 px-5 pt-2 pb-2 Navbar_button">Register</button></Link>
                </li>
                <label for="check" class="close-menu"><i class="fas fa-times"></i></label>
            </span>
            <label for="check" class="open-menu"><i class="fas fa-bars"></i></label>
        </ul>
    </nav>
    </div>
  )
}

export default Navbar_mobile
